import { render, staticRenderFns } from "./PriTama02.vue?vue&type=template&id=5100e9a7&scoped=true&"
import script from "./PriTama02.vue?vue&type=script&lang=js&"
export * from "./PriTama02.vue?vue&type=script&lang=js&"
import style0 from "./PriTama02.vue?vue&type=style&index=0&id=5100e9a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5100e9a7",
  null
  
)

export default component.exports